<template>
  <div class="cont">
    <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>

    <div class="task">
      <div class="title">
        <div class="t1">
          每日任务
          <b-img
            style="
              width: 74px;
              height: 14px;
              position: absolute;
              bottom: -6px;
              left: 7px;
            "
            :src="require('../assets/img/task/img1.png')"
            fit="contain"
          >
            <div slot="placeholder" class="image-slot"></div>
          </b-img>
        </div>
        <div class="t2">(每天0点刷新)</div>
      </div>

      <div class="t_cont">
        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">{{ curLevel }}</div>
            <div class="f3">积分</div>
          </div>

          <div class="l2 imageToimage">
            <div class="f1">每日登录</div>

            <el-popover
              placement="right"
              width="200"
              trigger="hover"
              content="连续登录可获取更多积分"
              popper-class="tps"
              effect="dark"
              :enterable="false"
            >
              <b-img
                class="f2"
                slot="reference"
                :src="require('../assets/img/task/img4.png')"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot"></div>
              </b-img>
            </el-popover>
          </div>

          <div class="l3">每日登录自动到账</div>
          <div class="l4">
            <div class="btn1">已完成</div>
          </div>
        </div>

        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">2</div>
            <div class="f3">积分</div>
          </div>
          <div class="l2 imageToimage">
            <div class="f1">发布作品</div>
          </div>

          <div class="l3">发布得2积分，快去完成吧~</div>
          <div class="l4">
            <div class="btn1" v-if="taskType2.status == 0">已完成</div>
            <div class="btn2" @click="taskFinish(1)" v-else>去发布</div>
          </div>
        </div>

        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">9</div>
            <div class="f3">积分</div>
          </div>
          <div class="l2 imageToimage">
            <div class="f1">作品点赞</div>
          </div>

          <div class="l3">3积分/次，快去完成吧~</div>
          <div class="l4" @click="taskFinish(2)">
            <div
              class="btn1"
              v-if="
                taskType3 &&
                taskType3.ext &&
                taskType3.ext.total <= taskType3.ext.count
              "
            >
              已完成
            </div>
            <div class="btn2" v-else>
              {{ taskType3 && taskType3.ext ? taskType3.ext.current : 0 }}/3
            </div>
          </div>
        </div>

        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">2</div>
            <div class="f3">积分</div>
          </div>
          <div class="l2 imageToimage">
            <div class="f1">作品分享</div>
          </div>

          <div class="l3">分享得2积分，快去完成吧~</div>
          <div class="l4">
            <div class="btn1" v-if="taskType4.status == 0">已完成</div>
            <div class="btn2" @click="taskFinish(3)" v-else>去分享</div>
          </div>
        </div>
<!-- 
        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">2</div>
            <div class="f3">积分</div>
          </div>
          <div class="l2 imageToimage">
            <div class="f1">作品应用</div>
          </div>

          <div class="l3">应用得2积分，快去完成吧~</div>
          <div class="l4">
            <div class="btn1" v-if="taskType5.status == 0">已完成</div>
            <div class="btn2" @click="taskFinish(4)" v-else>去应用</div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="task">
      <div class="title">
        <div class="t1">
          成长任务
          <b-img
            style="
              width: 74px;
              height: 14px;
              position: absolute;
              bottom: -6px;
              left: 7px;
            "
            :src="require('../assets/img/task/img1.png')"
            fit="contain"
          >
            <div slot="placeholder" class="image-slot"></div>
          </b-img>
        </div>
      </div>

      <div class="t_cont">
        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">20</div>
            <div class="f3">积分</div>
          </div>

          <div class="l2 imageToimage">
            <div class="f1">首次登录</div>
          </div>

          <div class="l3">仅限新用户</div>
          <div class="l4">
            <div class="btn1">已完成</div>
          </div>
        </div>
        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">5</div>
            <div class="f3">积分</div>
          </div>

          <div class="l2 imageToimage">
            <div class="f1">完善个人信息</div>
          </div>

          <div class="l3">完善个人信息，上传头像</div>
          <div class="l4">
            <div class="btn1" v-if="taskType6.status == 0">已完成</div>
            <div class="btn2" @click="taskFinish(5)" v-else>去完善</div>
          </div>
        </div>
        <div class="item">
          <div class="l1">
            <b-img
              class="f1"
              :src="require('../assets/img/task/img3.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </b-img>
            <div class="f2">5</div>
            <div class="f3">积分</div>
          </div>

          <div class="l2 imageToimage">
            <div class="f1">收藏网址</div>
          </div>

          <div class="l3">CTRL+D 收藏网址</div>
          <div class="l4">
            <div class="btn1" v-if="taskType7.status == 0">已完成</div>
            <div class="btn2" @click="taskFinish(6)" v-else>去收藏</div>
          </div>
        </div>
      </div>

      <div class="rule">
        <div class="title">积分规则</div>
        <div class="cont">
          <div class="line1">
            积分用途
            <div class="round">
              <div class="inner"></div>
            </div>
          </div>
          <div class="line2">
            积分可用于在Boser
            AI平台问答聊天和生成AI作品时使用，具体扣除数量请参考对应页面提示。
          </div>

          <div class="line1">
            每日登录
            <div class="round">
              <div class="inner"></div>
            </div>
          </div>
          <div class="line2">
            每日登录积分自动到账，连续登录7日依次获得2、4、5、6、7、8、10积分，7日后连续登录每日可得10积分，断登需重新累积。
          </div>
          <div class="line1">
            积分获取方式
            <div class="round">
              <div class="inner"></div>
            </div>
          </div>
          <div class="line2">
            用户可以选择<span style="color: #3d7af7">充值积分</span
            >或者通过做任务、参与平台活动等方式获取积分，任务完成或活动结束后，系统自动将积分发放到账户。
          </div>
          <div class="line1">
            重要声明
            <div class="round">
              <div class="inner"></div>
            </div>
          </div>
          <div class="line2">
            凡是以不正当手段(包括但不限于刷量、作弊、扰乱系统、实施网络攻击等)进行获取积分，平台有权终止该次获取，且对相应账号进行违规处理。平台保留随时对规则作出调整的最终解释权。
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 1px; margin-top: 33px"></div>
    <Status></Status>
  </div>
</template>

<script>
import { user_account_req } from "@/api/user";
import Navbar from "@/components/Navbar";
import LoginForm from "@/components/LoginForm";
import Status from "@/components/Status";
import {
  growth_tasks_req,
  growth_publish_req,
  growth_level_req,
} from "@/api/task";

export default {
  name: "TaskView",
  components: {
    Navbar,
    LoginForm,
    Status,
  },
  data() {
    return {
      loginFormShow: false,
      ac_data: {},
      showAccountInfo: false,
      taskType1: {
        ext: null,
        status: 1,
        type: 1,
      },
      taskType2: {
        ext: null,
        status: 1,
        type: 2,
      },
      taskType3: {
        ext: null,
        status: 1,
        type: 3,
      },
      taskType4: {
        ext: null,
        status: 1,
        type: 4,
      },
      taskType5: {
        ext: null,
        status: 1,
        type: 5,
      },
      taskType6: {
        ext: null,
        status: 1,
        type: 6,
      },
      taskType7: {
        ext: null,
        status: 1,
        type: 7,
      },
      taskType8: {
        ext: null,
        status: 1,
        type: 8,
      },

      curLevel: "",
    };
  },
  computed: {
    accountSettingVuex() {
      return this.$store.state.user.accountSetting;
    },
  },
  methods: {
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        if (data.ext) {
          data.ext = JSON.parse(data.ext);
        }
        this.ac_data = data;
      }
    },
    taskFinish(num) {
      if (num == 1) {
        //发布
        this.$router.push({
          path: `/text-image`,
        });
      } else if (num == 2) {
        //点赞
        this.$router.push({
          path: `/`,
        });
      } else if (num == 3) {
        //分享
        this.$router.push({
          path: `/personal?user=${encodeURIComponent(this.ac_data.uid)}`,
        });
      } else if (num == 4) {
        //应用
        // this.$toast.open({ message: '已完成,2积分已到账', position: 'top', duration: 1000, type: 'success' });
        this.$router.push({
          path: `/`,
        });
      } else if (num == 5) {
        //完善个人
        this.$store.commit("user/change_accountSetting", true);
      }
    },
    growthTasks() {
      growth_tasks_req().then((res) => {
        res.data.forEach((val) => {
          let _type = val.type;
          let str = "taskType" + _type;
          this[str].ext = val.ext;
          this[str].status = val.status;
        });
      });
    },
  },
  mounted() {
    this.getUserAccountInfo();
    this.growthTasks();
    growth_level_req().then((res) => {
      let c = res.data.current;
      if (c == 1) {
        this.curLevel = 2;
      } else if (c == 2) {
        this.curLevel = 4;
      } else if (c == 3) {
        this.curLevel = 5;
      } else if (c == 4) {
        this.curLevel = 6;
      } else if (c == 5) {
        this.curLevel = 7;
      } else if (c == 6) {
        this.curLevel = 8;
      } else if (c >= 7) {
        this.curLevel = 10;
      }
    });
    let _this = this;

    setTimeout(() => {
      document.onkeydown = null;
      document.onkeydown = function (e) {
        var keyCode = e.keyCode || e.which || e.charCode;
        var ctrlKey = e.ctrlKey || e.metaKey;
        if (ctrlKey && keyCode == 68) {
          growth_publish_req({
            type: 7,
          }).then((res) => {
            _this.growthTasks();
            growth_tasks_req({ type: 7 }).then((res1) => {
              if (res1.data[0].total == res1.data[0].count) {
                setTimeout(() => {
                  _this.$toast.open({
                    message: "收藏成功，5积分已到账",
                    position: "top",
                    duration: 3000,
                    type: "success",
                  });
                }, 1000);
              }
            });
          });
        }
        // e.preventDefault();
        // return false;
      };
    }, 500);
  },

  watch: {
    accountSettingVuex(newV, oldV) {
      if (!newV && oldV) {
        this.growthTasks();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cont {
  padding: 60px 84px 0;
  box-sizing: border-box;
  background-color: #0b0b1f;
}

.task {
  margin-top: 42px;
  .title {
    display: flex;
    align-items: center;
    height: 30px;
    color: #ffffff;
    line-height: 30px;
    margin-bottom: 20px;
    .t1 {
      font-size: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      position: relative;
    }
    .t2 {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      margin-left: 4px;
    }
  }
  .t_cont {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 236px;
      height: 236px;
      margin-right: 14px;
      margin-bottom: 14px;
      background: #1b1d2e;
      border-radius: 10px;
      border: 1px solid #2c2f42;
      background-image: url("../assets/img/task/img2.png") !important;
      background-position: center;
      background-size: 100%;
      .l1 {
        height: 66px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        color: #ffffff;
        margin-top: 20px;
        margin-bottom: 30px;
        .f1 {
          height: 20px;
          width: 20px;
        }
        .f2 {
          font-size: 66px;
          height: 66px;
          line-height: 82px;
          font-family: DINBold;
          margin-right: 6px;
        }
        .f3 {
          font-size: 18px;
          height: 25px;
          font-weight: 500;
          line-height: 28px;
        }
      }
      .l2 {
        height: 20px;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .f1 {
          margin-right: 1px;
          font-size: 20px;
          font-weight: 500;
        }
        .f2 {
          height: 16px;
        }
      }
      .l3 {
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        color: #9a9ab7;
        margin-top: 11px;
      }
      .l4 {
        display: flex;
        justify-content: center;
        margin-top: 12px;
        .btn1 {
          width: 88px;
          height: 32px;
          line-height: 32px;
          background: #252739;
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
          color: #9a9ab7;
          text-align: center;
          cursor: pointer;
        }
        .btn2 {
          width: 88px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(315deg, #006fff 0%, #72e3f5 100%);
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}

.rule {
  .title {
    margin-top: 40px;
    margin-bottom: 20px;
    height: 30px;
    font-size: 22px;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
  }
  .cont {
    padding: 17px 34px;
    box-sizing: border-box;
    background: #1b1d2e;
    border-radius: 10px;
    border: 1px solid #2c2f42;
    .line1 {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      margin-bottom: 7px;
      position: relative;
      .round {
        position: absolute;
        left: -18px;
        top: 5px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(0, 111, 255, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        .inner {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #006fff;
        }
      }
    }
    .line2 {
      margin-bottom: 12px;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      color: #cacad4;
      line-height: 22px;
    }
  }
}
</style>
